module.exports = __webpack_public_path__ + "img/send_fail.d1328044.svg";